import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {en} from "./language/en";
import {uk} from "./language/uk";
import {de} from "./language/de";

const resources = {
  en: {
    translation: en
  },
  uk: {
    translation: uk
  },
  // алиас для обратной совместимости: старые значения 'ua' в localStorage/БД
  ua: {
    translation: uk
  },
  de: {
    translation: de
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // язык по умолчанию при старте
    // если языка нет или ключ не переведён — берём английский; старый код 'ua' → 'uk'
    fallbackLng: { ua: ["uk", "en"], default: ["en"] },

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;